<template>
  <div class="app">
    <!-- <div class="fade" v-if="this.active==2">

    </div> -->
    <div class="mui-card">
      <div class="mui-card-footer rejectionRemarkArea" v-if="rejectionRemark">
        <span class="mui-card-footer-left" style="flex-shrink: 0;">驳回备注：</span>
        <span style="color:red;">{{rejectionRemark}}</span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 35%">所在建筑名称：</span>
        <span>{{ name }}</span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 35%;">所在位置：</span>
        <div class="mui-card-footer-right" style="width: 45%">
          <input style="margin-bottom: 0" v-model="locationRemark" :disabled="active==2" name="exitBlindFlag" value="1" class="input-text" type="text"
                 placeholder="请输入位置描述">
        </div>
      </div>
      <div class="mui-card-footer">
        <span>{{ position }}</span>
        <button class="mui-card-footer-left" style="width: 35%" @click="getBaiduPosition">{{ descc }}</button>
      </div>
      <div class="mui-card-footer" style="border-bottom: 1px solid #ccc">
        <span class="mui-card-footer-left">设施评价：</span>
        <span style="margin-right:16px">
            <Rate :score="score" :readonly="active==2" v-on:getScore="getScore"></Rate>
        </span>
      </div>
      <div class="mui-card">
        <span style="color: rgb(109, 109, 114);line-height: 28px;display: inline-block;width: 100%;padding-left: 5px;">设施情况</span>
        <div class="card">
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">是否为无障碍电梯：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.isaccessible" name="isaccessible" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">是</span>
              <span class="span-input-radio"><input v-model="formItem.isaccessible" name="isaccessible" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">否</span>
            </div>
          </div>

          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">出入口处盲道：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.exitBlindFlag" name="exitBlindFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.exitBlindFlag" name="exitBlindFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div radiobox">
            <span class="mui-card-footer-left radioleft">门开启方式：</span>
            <div class="mui-card-footer-right radioright">
              <span class="span-input-radio">
                <input v-model="formItem.moveDoorType" name="moveDoorType" value="1" class="input-radio" type="radio" :disabled="active==2">自助使用
              </span>
              <span class="span-input-radio">
                <input v-model="formItem.moveDoorType" name="moveDoorType" value="2" class="input-radio" type="radio" :disabled="active==2">需工作人员协助
              </span>
              <span class="span-input-radio">
                <input v-model="formItem.moveDoorType" name="moveDoorType" value="3" class="input-radio" type="radio" :disabled="active==2">已锁</span>
            </div>
          </div>


          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">运行显示装置：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio">
                <input v-model="formItem.moveShowFlag" name="moveShowFlag" value="1" class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio">
                <input v-model="formItem.moveShowFlag" name="moveShowFlag" value="0" class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">运行抵达声音提示：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.moveArrivalFlag" name="moveArrivalFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.moveArrivalFlag" name="moveArrivalFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">盲文按钮：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.brailleFlag" name="brailleFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.brailleFlag" name="brailleFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">逐层语音提示：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.floorSpeechFlag" name="floorSpeechFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.floorSpeechFlag" name="floorSpeechFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">扶手：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.handrailFlag" name="handrailFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.handrailFlag" name="handrailFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">轿厢壁上镜面材料：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.mirrorFlag" name="mirrorFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.mirrorFlag" name="mirrorFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">无障碍标志：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.signFlag" name="signFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.signFlag" name="signFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">紧急呼叫按钮：</span>
            <div class="mui-card-footer-right">
              <span class="span-input-radio"><input v-model="formItem.callValueFlag" name="callValueFlag" value="1"
                                                    class="input-radio" type="radio" :disabled="active==2">有</span>
              <span class="span-input-radio"><input v-model="formItem.callValueFlag" name="callValueFlag" value="0"
                                                    class="input-radio" type="radio" :disabled="active==2">无</span>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="mui-card-footer-div">



          </div>
          <div class="mui-card-footer-div" v-show="formItem.callValueFlag - 0">
            <span class="mui-card-footer-left" style="width: 45%">紧急呼叫按钮高度：</span>
            <div class="mui-numbox mui-card-footer-right">
              <input class="mui-input-numbox" type="number" v-model="formItem.callValue"/> cm
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">轿厢深度：</span>
            <div class="mui-numbox mui-card-footer-right">
              <input :disabled="active==2" class="mui-input-numbox" type="number" v-model="formItem.carDepthValue"/> cm
            </div>
          </div>
          <div class="mui-card-footer-div">
            <span class="mui-card-footer-left">轿厢宽度：</span>
            <div class="mui-numbox mui-card-footer-right">
              <input :disabled="active==2" class="mui-input-numbox" type="number" v-model="formItem.carWidthValue"/> cm
            </div>
          </div>
        </div>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施图片：</span>
        <div class="img-files flex">
          <div v-if='imgs.length>0' class="flex">
            <div class="img-box" v-for="(item, i) in imgs" :key='i'>
              <img :src="item" alt="" v-image-preview>
              <span @click="del(i)" v-if="active != 2"><i class="mui-icon mui-icon-close"></i></span>
            </div>
          </div>
          <div class="img-file" v-if='imgs.length < size'>
            <input type="file" id='files' accept="image/*" ref="updateFiles" @change='fileChange'>
          </div>
        </div>
        <span class="img-add-class" v-if="active!=2">
          <span class="mui-icon mui-icon-plus" @click="clickUpdateImage"></span>
        </span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left" style="width: 62%;">设施描述：</span>
        <span v-if="active !=2">
            <textarea name="" cols="30" rows="10" v-model="textAreaValue"></textarea>
            <span class="mui-badge" @click="addComment('非常方便')" ref="comment1">非常方便</span>
            <span class="mui-badge" @click="addComment('完全无障碍')" ref="comment2">完全无障碍</span>
            <span class="mui-badge" @click="addComment('设施完好，赞！')" ref="comment3">设施完好，赞！</span>
            <span class="mui-badge" @click="addComment('设施不可用')" ref="comment3">设施不可用</span>
          <span class="mui-badge" @click="addComment('仅可用，不是很方便！')" ref="comment3">仅可用，不是很方便！</span>
          </span>
        <span v-else>
            <textarea name="" :disabled="active==2" cols="30" rows="10" v-model="textAreaValue" style="margin-bottom: 0"></textarea>
          </span>
      </div>
     
    </div>
    <div class="mui-card" v-if="this.active === '1' || this.active === '3'">
      <mt-button type="primary" @click="clickSubmit">上传</mt-button>
    </div>
    <div class="mui-card" v-if="showReEditBtn">
      <mt-button type="primary" @click="reEdit">重新编辑</mt-button>
    </div>
  </div>
</template>

<script>
import Rate from '../common/Rate'
import {Toast} from 'mint-ui'
import {Indicator} from 'mint-ui';

import {lib_getPosition} from '../../utils/getLocation'
import { compressImage,compressImageWithout } from '../../utils/compressImage'
import {getUserLocation,configureWechatSDK} from '../../utils/wechatSDK'
import {generateRandomFileName,ossClient} from "../../utils/oss_config"
export default {
  name: 'lift',
  data() {
    return {
      descc:"获取当前定位",
      position:{"lat":0,"lng":0},
      textAreaValue: '',
      locationRemark: '',
      formItem: {
        doorWidth: '0',
        callValue: '0',
        carDepthValue: '0',
        carWidthValue: '0',
        exitBlindFlag: 0,
        moveShowFlag: 0,
        moveArrivalFlag: 0,
        brailleFlag: 0,
        floorSpeechFlag: 0,
        handrailFlag: 0,
        mirrorFlag: 0,
        signFlag: 0,
        callValueFlag: 0,
        moveDoorType: 1,
        isaccessible:'1',
      },
      returnImgs: [],
      score: null,
      imgs: [],
      imgfiles: [],
      size: 5,
      title: '垂直电梯',
      active: this.$route.params.active=='20'?'2':this.$route.params.active,
      showReEditBtn: this.$route.params.active=='20'?true:false,//当是自己的上报记录且审核状态为待审核或审核驳回时，显示重新编辑按钮，点击后切换为编辑模式
      task_id: this.$route.params.taskId,
      building_id: this.$route.params.buildingId,
      buildingdevicetype_id: this.$route.params.facilitiesTypeId,
      id: this.$route.params.id,
      host: process.env.BASE_URL,
      name: '',
      savedata: {},
      currentPosi: [], //当前位置坐标
      rejectionRemark: '',//驳回备注
    }
  },
  created() {
    this.$emit('getTitle', this.title)
    this.getChildBuildingInfo()
    this.initMsg()

    var that = this;
    var getCurrentLocationInterval = setInterval(function () {
       that.getData(that, that.currentPosi, function(){
        clearInterval(getCurrentLocationInterval)
      });
    }, 1000);
    //销毁定时器
    this.$once("hook:beforeDestroy", () => {
      clearInterval(getCurrentLocationInterval);
    });

  },
  methods: {
    submitImageWithOss(imgId,fileExtension){
      Indicator.open("上传中...");
      
      const file = this.imgfiles[imgId].get('file');
      const fileName = generateRandomFileName(fileExtension); // 自定义文件名

      ossClient.put(fileName, file).then(result => {
        // 上传成功
        const imageUrl = result.url; // 上传成功后返回的图片URL
        this.returnImgs.push(imageUrl);
        Indicator.close();
        Toast("上传成功")
      }).catch(error => {
        // 上传失败
        console.error('Failed to upload the image:', error);
      });

    },
    async getBaiduPosition(){
      this.descc="正在获取当前定位"
      lib_getPosition().then(res=>{
        this.position={"lat":res.latitude, "lng":res.longitude}
        this.descc="获取当前定位"
      },()=>{
        this.position="获取失败，请重新获取"
        this.descc="获取当前定位"
      })
      
    },
    insertdata() {

      let savedata = localStorage.getItem(this.building_id + ',' + this.buildingdevicetype_id)

      if (savedata === null || savedata === undefined || savedata === '') {
        return;
      } else {
        Toast("已自动导入上一次数据")
      }

//      自己导入存储数据
      let savedataobj = JSON.parse(savedata)

      if (savedataobj.formItem) {
        this.formItem = savedataobj.formItem
      }
      // if (savedataobj.locationRemark) {
      //   this.locationRemark = savedataobj.locationRemark
      // }
      if (savedataobj.score) {
        this.score = savedataobj.score
      }
      if (savedataobj.textAreaValue) {
        this.textAreaValue = savedataobj.textAreaValue
      }


    },
    clickUpdateImage() {
      this.$refs.updateFiles.click()
    },
    fileChange() {
      var _this = this
      var event = window.event
      var file = event.target.files
      var reader = new FileReader()
      let formData = new FormData()
      const fileName = file[0].name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
      compressImageWithout(file[0], 800000, 6000000, 0.4).then((res) => {
        // console.log('压缩之后图片尺寸大小: ', res.size / 1024)
        // console.log('实际压缩率： ', ((file[0].size - res.size) / file[0].size * 100).toFixed(2) + '%');
        formData.append('file', new File([res], 'my-image1.png', { type: 'image/png' }))
        _this.imgfiles.push(formData)
        reader.readAsDataURL(new File([res], 'my-image1.png', { type: 'image/png' }))
        reader.onload = function (e) {
          _this.imgs.push(e.target.result)
        }
        // _this.submitImage(0)
        _this.submitImageWithOss(0,fileExtension)
        this.imgfiles.splice(0, 1)
      })

    },
    del(i) {
      this.imgs.splice(i, 1)
      this.returnImgs.splice(i, 1)
    },
    addComment(val) {
      if (this.textAreaValue === '') {
        this.textAreaValue = this.textAreaValue + val
      } else {
        this.textAreaValue = this.textAreaValue + ',' + val
      }
    },
    reEdit(){
      this.active = '3';
      this.showReEditBtn = false;
    },
    clickSubmit () {
     if (this.locationRemark === '') {
        Toast('请输入位置信息')
        return false
      }
      if(this.returnImgs.length == 0){
        Toast('请上传设施图片')
        return false
      }
      // if(this.position.lat==0){
      //   Toast('请获取当前定位')
      //   return false
      // }
      this.submitpostdata()
    },
    submitImage(imgId) {
      Indicator.open('上传中...');
      this.$http.post('api/gather/uplaodimg', this.imgfiles[imgId], {headers: {'Content-Type': 'multipart/form-data'}})
        .then(function (data) {
          Indicator.close();
          if (data.body.code === 1) {
            this.returnImgs.push(data.body.data.url)
          }
        }).catch(error => {
        Indicator.close();
        Toast("网络错误！")
      }).catch(error => {
        Indicator.close();
        Toast("网络错误！")
      })
    },
    submitpostdata() {

      Indicator.open('提交中...');
      if (this.active === '1') {
        this.$http.post('api/gather/submitpostdata', {
          'task_id': this.task_id,
          'building_id': this.building_id,
          'buildingdevicetype_id': this.buildingdevicetype_id,
          'score': this.score,
          'positiondesc': this.locationRemark,
          'devicedesc': this.formItem,
          'desc': this.textAreaValue,
          "baidu_position":`{lat:${this.position.lat},lng:${this.position.lng}}`,
          'images': this.returnImgs.join(','),
          'position': this.currentPosi
        }, {emulateJSON: true})
          .then(function (data) {
            if (data.body.code === 1) {
              Indicator.close();
              Toast('上传成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 1500)
            } else {
              Toast(data.body.msg)
            }
          }).catch(error => {
          Indicator.close();
          Toast("网络错误！")
        })
      } else {
        this.$http.post('api/gather/editpostdata', {
          'id': this.id,
          'task_id': this.task_id,
          'building_id': this.building_id,
          'buildingdevicetype_id': this.buildingdevicetype_id,
          'score': this.score,
          'positiondesc': this.locationRemark,
          'devicedesc': this.formItem,
          'desc': this.textAreaValue,
          'images': this.returnImgs.join(',')
        }, {emulateJSON: true})
          .then(function (data) {
            if (data.body.code === 1) {
              Indicator.close();
              Toast('上传成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 1500)
            } else {
              Toast(data.body.msg)
            }
          }).catch(error => {
          Indicator.close();
          Toast("网络错误！")
        })
      }

    },
    getScore(score) {
      this.score = score
    },
    initMsg() {
      if (this.active === '2' || this.active === '3') {
        this.$http.get('api/gather/checkPostInfo?id=' + this.id)
          .then(function (data) {
            if (data.body.code === 1) {
              data = data.body.data.info
              data.devicedesc = JSON.parse(data.devicedesc)
              let Imgs = [];
              if(data.images){
                Imgs = data.images.split(',')
              }
              this.rejectionRemark = data.remark;
              this.textAreaValue = data.desc
              this.formItem = data.devicedesc
              // this.formItem.doorWidth = data.devicedesc.doorWidth
              // this.formItem.callValue = data.devicedesc.callValue
              // this.formItem.carDepthValue = data.devicedesc.carDepthValue
              // this.formItem.carWidthValue = data.devicedesc.carWidthValue
              // this.formItem.exitBlindFlag = data.devicedesc.exitBlindFlag
              // this.formItem.moveShowFlag = data.devicedesc.moveShowFlag
              // this.formItem.moveArrivalFlag = data.devicedesc.moveArrivalFlag
              // this.formItem.brailleFlag = data.devicedesc.brailleFlag
              // this.formItem.floorSpeechFlag = data.devicedesc.floorSpeechFlag
              // this.formItem.handrailFlag = data.devicedesc.handrailFlag
              // this.formItem.mirrorFlag = data.devicedesc.mirrorFlag
              // this.formItem.signFlag = data.devicedesc.signFlag
              // this.formItem.callValueFlag = data.devicedesc.callValueFlag
              // this.formItem.moveDoorType = data.devicedesc.moveDoorType
              this.score = data.score
              this.locationRemark = data.positiondesc
              for (let i = 0; i < Imgs.length; i++) {
                this.imgs[i] = this.host + Imgs[i]
                this.returnImgs[i] = Imgs[i]
              }
            } else {
              Toast(data.body.msg)
            }
          }).catch(error => {
          Indicator.close();
          Toast("网络错误！")
        })
      }else{
        this.insertdata()
      }
    },
    getChildBuildingInfo() {
      this.$http.get('api/gather/getChildBuildingInfo?id=' + this.building_id)
        .then(function (data) {
          if (data.body.code === 1) {
            this.name = data.body.data.list.building.name
          }
        }).catch(error => {
        Indicator.close();
        Toast("网络错误！")
      })

    }
  },
  components: {
    Rate: Rate
  },

  watch: {
    formItem: {
      handler(newValue, oldValue) {
        this.savedata.formItem = newValue;
        localStorage.setItem(this.building_id + ',' + this.buildingdevicetype_id, JSON.stringify(this.savedata))

      },
      deep: true
    },
    locationRemark: function (newValue) {
      this.savedata.locationRemark = newValue;
      localStorage.setItem(this.building_id + ',' + this.buildingdevicetype_id, JSON.stringify(this.savedata))

    },
    score(newValue) {
      this.savedata.score = newValue;
      localStorage.setItem(this.building_id + ',' + this.buildingdevicetype_id, JSON.stringify(this.savedata))

    },
    textAreaValue(newValue) {
      this.savedata.textAreaValue = newValue;
      localStorage.setItem(this.building_id + ',' + this.buildingdevicetype_id, JSON.stringify(this.savedata))
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.app {
  margin-bottom: 15px;
}
.radiobox{
  position: relative;
  height: 140px;
  width: 100%;
}
.radioleft{
  // position: absolute;
  // height: 30px;
  // left: 0;
  // top: 55px;
}

.img-files {
  width: 70%;
  float: right;

  .flex {
    width: 85%;
    display: inline-block;
  }

  .img-box {
    width: 60px;
    height: 60px;
    position: relative;
    border: 1px solid #e6e6e6;
    margin-right: 10px;
    background-color: white;
    float: left;
    text-align: center;

    img {
      max-width: 60px;
      max-height: 60px;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    span {
      position: absolute;
      top: -10px;
      left: 48px;
      color: red;
      display: block;
    }

    &:hover span {
      display: block;
    }
  }

  .img-add-class {
    width: 10%;
  }
}

.img-file {
  display: none;
  align-items: center;

  > input {
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  > label {
    position: absolute;
    font-size: 14px;
    color: #333;
  }
}

.mui-card {
  button {
    width: 100%;
  }
}

.mui-card-header {
  font-size: 15px;
}

select {
  margin: 0px;
  padding: 0px;
  background-color: #EFEFEF;
  text-align: center;
}

.mui-card-footer-left {
  // width: 25%;
  display: inline-block;
  line-height: 28px;
}

.mui-card-footer-right {
  .input-text {
    margin-bottom: 0px;
  }
}

.card {
  border-top: 1px solid #ccc;
  color: #6d6d72;
  padding: 10px 15px;

  .mui-card-footer-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 2px 0;

    .mui-card-footer-left {
      // width: 25%;
      display: inline-block;
      line-height: 28px;
    }

    .mui-card-footer-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
      // float: right;
      // width: 135px;
      padding: 0;

      .mui-input-numbox {
        padding: 0;
        // width: 100px;
      }

      .span-input-radio {
        // width: 45%;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        line-height: 28px;
        margin: 0 30px;
      }
    }
  }
}
.radioright{
  // position: absolute;
  // height: 100px;
  // right: 0;
  // top: 20px;
  flex-direction: column!important;;
  align-items: flex-start!important;
  justify-content: center!important;;
}
.rejectionRemarkArea{
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Facilities/lift.vue